package com.ijoin.platform

import kotlinx.browser.window

/**
 * JS implementation - opens URL in new tab.
 */
actual fun openUrl(url: String) {
    window.open(url, "_blank")
}

/**
 * JS implementation - opens URL in new tab (same as openUrl).
 */
actual fun openUrlInApp(url: String) {
    openUrl(url)
}

/**
 * JS implementation - redirect in the same tab.
 */
actual fun redirectToUrl(url: String) {
    window.location.href = url
}
